var React = require('react');

function AddToolboxIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"64","height":"64","key":0}),React.createElement("path",{"fill":"#2F3641","d":"M54,15 L59,15 L59,18 L54,18 L54,23 L51,23 L51,18 L46,18 L46,15 L51,15 L51,10 L54,10 L54,15 Z M20,27 L20,24 C20,21.790861 21.790861,20 24,20 L40,20 C42.209139,20 44,21.790861 44,24 L44,27 L46,27 C47.1045695,27 48,27.8954305 48,29 L48,34 L16,34 L16,29 C16,27.8954305 16.8954305,27 18,27 L20,27 Z M23,27 L41,27 L41,24 C41,23.4477153 40.5522847,23 40,23 L24,23 C23.4477153,23 23,23.4477153 23,24 L23,27 Z M16,36 L48,36 L47.1528258,46.166091 C47.0664437,47.2026752 46.1999115,48 45.1597342,48 L18.8402658,48 C17.8000885,48 16.9335563,47.2026752 16.8471742,46.166091 L16,36 Z","key":1})]));
}

AddToolboxIcon.defaultProps = {"width":"64","height":"64","viewBox":"0 0 64 64"};

module.exports = AddToolboxIcon;

AddToolboxIcon.default = AddToolboxIcon;
